/* eslint-disable react-hooks/exhaustive-deps */
import { IMeetingInfo } from "@/common/entity/Entity";
import { transformToTree } from "@/common/function/ArrayFunction";
import {
  MapActiveIcon,
  MapActiveIconLocation,
  RenderIconNext,
  RenderIconPre,
  RenderIconZoom
} from "@/components/ui/Icons/IconsCustom";
import { E_SIZE } from "@/components/ui/Loading/Models";
import Nodata from "@/components/ui/Nodata";
import TreeSelect from "@/components/ui/TreeSelect";
import {
  ICategorizationInfo,
  ITreeInfo,
} from "@/components/ui/TreeSelect/Models";
import { RootState } from "@/redux";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import {
  IFilterResource,
  IFilterResourceRequest,
  TransitiveMemberOfGroup,
} from "@/services";
import { DateTimePeriod } from "@/services/organization-service/entity/OutLookEntity";
import {
  FloorPlanInfo,
  IFetchFloorPlanRequest,
} from "@/services/resource-service/entity/FloorplanEntity";
import { Spinner } from "@fluentui/react-components";
import { cloneDeep } from "lodash";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IFloorPlanProps } from "./Models";
import {
  FloorPlanActionWrapper,
  FloorPlanBaseWrapper,
  FloorPlanContentWrapper,
  FloorPlanHeaderWrapper,
  FloorPlanNextAndPrevWrapper,
  FloorPlanZoomWrapper,
  RenderIconWrapper,
} from "./Styles";
import DrawFloorPlan from "./draw-floor-plan/DrawFloorPlanContainer";
import { IResourceStore } from "@/redux/slices/resources/ResourceReducerModel";
import { EColorPermissionFloorPlan } from "@/common/entity/Enum";
import { FloorPlanEvents } from "./FloorPlanEvents";

const ResourceFloorPlan = (props: IFloorPlanProps) => {
  const { t } = useTranslation();
  const theme: string = useSelector(
    (state: RootState) => state.settingInfo?.theme
  ) as string;

  const state: RootState = useSelector(
    (state: RootState) => state
  ) as RootState;
  const orgStore: IOrganizationStore = state.orgInfo as IOrganizationStore;

  const resourceStore: IResourceStore = useSelector(
    (state: RootState) => state.resources
  ) as IResourceStore;

  const locationList: ICategorizationInfo[] =
    state?.orgInfo?.locationList || [];
  const filter: IFilterResource | null = state?.resources?.filterResource;

  const [dataTreeLocation, setDataTreeLocation] = useState<ITreeInfo[]>([]);
  const [resourceFloorPlanRequest, setResourceFloorPlanRequest] =
    useState<IFetchFloorPlanRequest | null>(null);
  const [listLocationHaveFloorPlan, setListLocationHaveFloorPlan] = useState<
    string[]
  >([]);
  const [loadingNextPrev, setLoadingNextPrev] = useState<boolean>(false);
  const [floorPlanInfo, setFloorPlanInfo] = useState<FloorPlanInfo | null>(
    null
  );

  const { onFetchResourceFloorPlan } = props;

  const treeSelectRef = useRef<any>(null);

  useEffect(() => {
    const hideDropdown = () => {
      if (treeSelectRef.current) {
        treeSelectRef.current.onChangeToggleContextMenu(false);
      }
    };

    FloorPlanEvents.ElementMouseOver.Subscribe(hideDropdown);

    return () => {
      FloorPlanEvents.ElementMouseOver.UnSubscribe();
    };
  }, []);

  useEffect(() => {
    if (resourceFloorPlanRequest && !resourceStore.isLoadingSelectedRs) {
      fetchResourceFloorPlanService(resourceFloorPlanRequest);
    }
  }, [resourceFloorPlanRequest, resourceStore.isLoadingSelectedRs]);

  useEffect(() => {
    const locationHaveFloorPlanClone: string[] = (
      locationFilterFloorplan() || []
    )
      .filter((item) => item.isUsedFloorPlan)
      .map((locationInfo) => locationInfo.guid);
    if (orgStore.orgInfo && locationHaveFloorPlanClone.length) {
      const filterReq: IFilterResourceRequest | null = filter
        ? {
          CategoryIds: filter?.categoryIds?.length
            ? filter.categoryIds.join(` ${filter.categoryCondition || "or"} `)
            : null,
          ResourceTypes: filter.resourceTypes || null
        }
        : null;
      fetchResourceFloorPlan(
        filterReq,
        locationHaveFloorPlanClone[filter?.indexLocation || 0]
      );
    }
  }, [JSON.stringify(filter), orgStore.orgInfo, orgStore.outlookInfo]);

  useEffect(() => {
    initLocationFloorPlan();
  }, [JSON.stringify(filter?.locationIds)]);

  const initLocationFloorPlan = () => {
    if (locationList.length) {
      const treeTempSort: ITreeInfo[] = transformToTree(
        locationFilterFloorplan(),
        "guid",
        "parentId"
      );
      const locationHaveFloorPlanClone: string[] = locationFilterFloorplan()
        .filter((item) => item.isUsedFloorPlan)
        .map((locationInfo) => locationInfo.guid);
      setDataTreeLocation(treeTempSort);
      setListLocationHaveFloorPlan(locationHaveFloorPlanClone);
    }
  };

  const fetchResourceFloorPlan = async (
    filters?: IFilterResourceRequest | null,
    locationId?: string
  ): Promise<void> => {
    if (
      orgStore.orgInfo &&
      orgStore.outlookInfo &&
      orgStore.organizer &&
      locationId
    ) {
      const meetingInfos: IMeetingInfo[] = orgStore.outlookInfo
        .isRecurringMaster
        ? (orgStore.outlookInfo?.occurrences || [])?.map(
          (item: DateTimePeriod) => {
            return {
              StartTime: item.start?.toISOString() || "",
              EndTime: item.end?.toISOString() || "",
              Guid: orgStore.orgInfo?.isExternal ? (orgStore.orgInfo?.uidOutlook || undefined) : orgStore.orgInfo?.iCalUId,
            };
          }
        )
        : [
          {
            StartTime: orgStore.outlookInfo.start?.toISOString() || "",
            EndTime: orgStore.outlookInfo.end?.toISOString() || "",
            Guid: orgStore.orgInfo?.isExternal ? (orgStore.orgInfo?.uidOutlook || undefined) : orgStore.orgInfo?.iCalUId,
          },
        ];

      const request: IFetchFloorPlanRequest = {
        orgId: orgStore.orgInfo.guid,
        tenantId: orgStore.orgInfo.tenantId,
        requestBody: {
          Organizer: orgStore.organizer.email,
          IsRecurring: !!orgStore.outlookInfo.isRecurringMaster,
          EmailGroups: orgStore.orgInfo.memberOfs.map(
            (item: TransitiveMemberOfGroup) => item.mail
          ),
          MeetingInfos: meetingInfos,
          Filters: filters || null,
          LocationId: locationId,
        },
      };
      setResourceFloorPlanRequest(request);
    }
  };

  const locationFilterFloorplan = (): ICategorizationInfo[] => {
    const locationListClone = cloneDeep(locationList);
    if (locationListClone.length && filter?.locationIds?.length) {
      return locationListClone.filter((item: ICategorizationInfo) =>
        filter?.locationIds?.includes(item.guid)
      );
    }
    return locationListClone;
  };

  const nextLocation = (indexLocation?: number) => {
    const filterClone = filter ? cloneDeep(filter) : ({} as IFilterResource);
    filterClone.indexLocation =
      indexLocation !== undefined
        ? indexLocation
        : (filterClone?.indexLocation || 0) + 1;
    if (props.updateFilterResource) {
      props.updateFilterResource(filterClone);
    }
  };

  const prevLocation = () => {
    const filterClone = filter ? cloneDeep(filter) : ({} as IFilterResource);
    filterClone.indexLocation = (filterClone?.indexLocation || 1) - 1;
    if (props.updateFilterResource) {
      props.updateFilterResource(filterClone);
    }
  };

  const onShowFloorPlanDialog = () => {
    if (props.showFloorPlanDialog) {
      props.showFloorPlanDialog(state);
    }
  };

  const fetchResourceFloorPlanService = async (
    resourceRequest: IFetchFloorPlanRequest | null
  ): Promise<void> => {
    if (onFetchResourceFloorPlan && resourceRequest) {
      setLoadingNextPrev(true);
      const response = await onFetchResourceFloorPlan(resourceRequest);
      setFloorPlanInfo(response);
      setLoadingNextPrev(false);
    } else {
      setFloorPlanInfo(null);
    }
  };

  const renderNameLocation = (): string => {
    const locationInfo: ITreeInfo | undefined = locationList.find(
      (item) =>
        item.guid === listLocationHaveFloorPlan[filter?.indexLocation || 0]
    );
    if (locationInfo) {
      return locationInfo.name;
    }
    return "Locations";
  };

  const onChangeLocations = (arr: string[]) => {
    const indexLocation: number | undefined =
      listLocationHaveFloorPlan.findIndex((guid: string) => guid === arr[0]);
    if (indexLocation !== undefined && indexLocation !== -1) {
      nextLocation(indexLocation);
    }
  };

  return (
    <FloorPlanBaseWrapper className="FloorPlanBaseWrapper" $theme={theme}>
      <FloorPlanHeaderWrapper className="FloorPlanHeaderWrapper">
        <FloorPlanActionWrapper className="FloorPlanActionWrapper">
          <TreeSelect
            ref={treeSelectRef}
            items={dataTreeLocation}
            values={
              listLocationHaveFloorPlan[filter?.indexLocation || 0]
                ? [listLocationHaveFloorPlan[filter?.indexLocation || 0]]
                : []
            }
            size="small"
            onChange={onChangeLocations}
            iconLeft={<MapActiveIconLocation theme={theme} />}
            iconLeftActive={<MapActiveIcon theme={theme} />}
            displayLabelValue={t(renderNameLocation())}
            lblSelect={t("Locations")}
            style={{ minWidth: "100%" }}
            expanded={
              listLocationHaveFloorPlan[filter?.indexLocation || 0]
                ? [listLocationHaveFloorPlan[filter?.indexLocation || 0]]
                : []
            }
            theme={theme}
            rcName="location_available_floorplan"
            isNotCheckbox
          />
          <FloorPlanNextAndPrevWrapper className="FloorPlanNextAndPrevWrapper">
            <RenderIconWrapper
              onClick={!filter?.indexLocation ? undefined : prevLocation}
              $isDisable={!filter?.indexLocation}
            >
              <RenderIconPre theme={theme} />
            </RenderIconWrapper>
            <RenderIconWrapper
              onClick={() =>
                (filter?.indexLocation || 0) ===
                  listLocationHaveFloorPlan.length - 1 || !listLocationHaveFloorPlan.length
                  ? undefined
                  : nextLocation()
              }
              $isDisable={
                (filter?.indexLocation || 0) ===
                listLocationHaveFloorPlan.length - 1 || !listLocationHaveFloorPlan.length
              }
            >
              <RenderIconNext theme={theme} />
            </RenderIconWrapper>
          </FloorPlanNextAndPrevWrapper>
        </FloorPlanActionWrapper>
        <FloorPlanZoomWrapper
          className="FloorPlanZoomWrapper"
          onClick={onShowFloorPlanDialog}
        >
          <RenderIconZoom theme={theme} />
        </FloorPlanZoomWrapper>
      </FloorPlanHeaderWrapper>
      <FloorPlanContentWrapper
        className="FloorPlanContentWrapper"
        $maxHeight={props.maxHeight}
      >
        {loadingNextPrev ? (
          <Spinner size={E_SIZE.medium} />
        ) : (
          <div className="floor-header inner">
            {floorPlanInfo ? (
              <DrawFloorPlan floorPlanInfo={floorPlanInfo} maxHeight={props.maxHeight} />
            ) : (
              <>
                <Nodata />
                <br />
              </>
            )}
          </div>
        )}
        <div className="floor-box-status-container">
          <div className="floor-box-status-header">
            <div className="frame-427323071">
              <div className="rectangle-24312" style={{ background: EColorPermissionFloorPlan.Available }}></div>
              <div className="available">{t("Available")}</div>
            </div>

            <div className="frame-427323079">
              <div className="rectangle-243125" style={{ background: EColorPermissionFloorPlan.Disable }}></div>
              <div className="closed">{t("Unavailable")}</div>
            </div>

            <div className="frame-4273230762">
              <div className="rectangle-243122" style={{ background: EColorPermissionFloorPlan.Selected }}></div>
              <div className="selected">{t("Selected")}</div>
            </div>

            {/* <div className="frame-427323077">
              <div className="rectangle-243123"></div>
              <div className="own">Own</div>
            </div> */}

            {/*<div className="frame-427323078">*/}
            {/*  <div className="rectangle-243124"></div>*/}
            {/*  <div className="booked">{t("Booked")}</div>*/}
            {/*</div>*/}
          </div>
        </div>
      </FloorPlanContentWrapper>
    </FloorPlanBaseWrapper>
  );
};

export default ResourceFloorPlan;
